import * as React from "react";
import { useUser } from "../../globalState";
import { Box } from "../../themeV2";
import FamilyMember from "./FamilyMember";

export default function UserBadges() {
  const user = useUser();

  return user.isStreamilyFamilyMember ? (
    <Box padding={2}>
      <FamilyMember />
    </Box>
  ) : null;
}
